import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'Loqed',
	friendly_name: 'Loqed',
	family: 'lock',
	category: 'lock',
	isPM: false,
	reset_from_input: false,
	modes: {
		lock: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
					],
				},
				share,
				{
					title: 'settings',
					components: [{ title: 'device_information', component: 'device_information' }],
				},
			],
		},
	},
};
